import service from "@/service/index";
import Vue from "vue";
import svgInstall from "@/icons";
Vue.prototype.$service = service;
svgInstall();
import "./elementui";
import "./vueImg";
import "./VueClipboard";
// import "./logger";
import "./sentry";
Vue.directive("selectLoadMore", {
  bind(el: any, binding: any) {
    const selectDom = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
    if (!selectDom) {
      return;
    }
    selectDom.addEventListener("scroll", function (e: any) {
      const height = e.target.scrollHeight - e.target.scrollTop - 2 <= e.target.clientHeight;
      console.warn(e.target.scrollHeight, e.target.scrollTop, e.target.clientHeight, height);
      if (height && e.target.scrollTop !== 0) {
        binding.value();
      }
    });
  },
});
